<div class="container-fluid">
  <h1 class="h3 mb-4">Database Statistics</h1>
  <div class="row">
    <!-- Server Status & Connections -->
    <div class="col-12 col-lg-6 mb-4">
      <div class="card" [ngClass]="{'border-danger': connectionWarning}">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span>
            Connections
            <span *ngIf="connectionWarning" class="badge badge-danger ms-2">
              High Usage: {{ connectionPercentage | number:'1.0-1' }}%
            </span>
          </span>
          <small *ngIf="serverInfo" class="text-muted">
            v{{ serverInfo.version }} | Uptime: {{ serverInfo.uptime | number }} s
          </small>
        </div>
        <div class="card-body">
          <div>
            <canvas baseChart
                    [data]="connectionsData"
                    [options]="chartOptions"
                    [type]="chartType">
            </canvas>
          </div>
          <div class="progress mt-3">
            <div class="progress-bar"
                 [ngClass]="{'bg-danger': connectionWarning, 'bg-success': !connectionWarning}"
                 [style.width.%]="connectionPercentage">
              {{ connectionPercentage | number:'1.0-1' }}%
            </div>
          </div>
        </div>
        <div class="card-footer" *ngIf="serverInfo">
          <small [ngClass]="{'text-danger': connectionWarning}">
            {{ serverInfo.currentConnections }} active /
            {{ serverInfo.currentConnections + serverInfo.availableConnections }} total connections
          </small>
        </div>
      </div>
    </div>

    <!-- Active Operations -->
    <div class="col-12 col-lg-6 mb-4">
      <div class="card">
        <div class="card-header">
          Active Operations
        </div>
        <div class="card-body">
          <div>
            <canvas baseChart
                    [data]="operationsData"
                    [options]="chartOptions"
                    [type]="chartType">
            </canvas>
          </div>
        </div>
        <div class="card-footer" *ngIf="operationStatsHistory.length > 0">
          <small>
            Current: {{ operationStatsHistory[operationStatsHistory.length - 1].data.activeOperations }} active
            operations
          </small>
        </div>
      </div>
    </div>

    <!-- Database Statistics -->
    <div class="col-12 col-lg-6 mb-4">
      <div class="card">
        <div class="card-header">
          Database Statistics
        </div>
        <div class="card-body">
          <table class="table table-sm table-hover" *ngIf="latestDatabaseStats">
            <tbody>
            <tr>
              <th>Collections</th>
              <td class="text-right">{{ latestDatabaseStats.collections | number }}</td>
            </tr>
            <tr>
              <th>Views</th>
              <td class="text-right">{{ latestDatabaseStats.views | number }}</td>
            </tr>
            <tr>
              <th>Objects</th>
              <td class="text-right">{{ latestDatabaseStats.objects | number }}</td>
            </tr>
            <tr>
              <th>Data Size</th>
              <td class="text-right">{{ formatBytes(latestDatabaseStats.dataSize) }}</td>
            </tr>
            <tr>
              <th>Storage Size</th>
              <td class="text-right">{{ formatBytes(latestDatabaseStats.storageSize) }}</td>
            </tr>
            <tr>
              <th>Indexes</th>
              <td class="text-right">{{ latestDatabaseStats.indexes | number }}</td>
            </tr>
            <tr>
              <th>Index Size</th>
              <td class="text-right">{{ formatBytes(latestDatabaseStats.indexSize) }}</td>
            </tr>
            <tr>
              <th>Total Size</th>
              <td class="text-right">{{ formatBytes(latestDatabaseStats.totalSize) }}</td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="!latestDatabaseStats" class="text-center text-muted">
            Loading database statistics...
          </div>
        </div>
      </div>
    </div>

    <!-- Server Status -->
    <div class="col-12 col-lg-6 mb-4">
      <div class="card">
        <div class="card-header">
          Server Status
        </div>
        <div class="card-body">
          <table class="table table-sm table-hover" *ngIf="serverInfo">
            <tbody>
            <tr>
              <th>Version</th>
              <td class="text-right">{{ serverInfo.version }}</td>
            </tr>
            <tr>
              <th>Uptime</th>
              <td class="text-right">{{ serverInfo.uptime | number }} seconds</td>
            </tr>
            <tr>
              <th>Current Connections</th>
              <td class="text-right">{{ serverInfo.currentConnections }}</td>
            </tr>
            <tr>
              <th>Available Connections</th>
              <td class="text-right">{{ serverInfo.availableConnections }}</td>
            </tr>
            <tr>
              <th>Connection Usage</th>
              <td class="text-right" [ngClass]="{'text-danger': connectionWarning}">
                {{ connectionPercentage | number:'1.0-1' }}%
              </td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="!serverInfo" class="text-center text-muted">
            Loading server information...
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
